import { Alert as BaseAlert } from "@mui/material";
import styled from "@mui/styled-engine";

const StyledAlert = styled(BaseAlert)(({ theme, severity }) => {
  const stylesMap = {
    success: {
      backgroundColor: theme.palette.success.background,
      border: `2px solid ${theme.palette.success.main}`,
    },
    error: {
      backgroundColor: theme.palette.error.background,
      border: `2px solid ${theme.palette.error.main}`,
    },
    warning: {
      backgroundColor: theme.palette.warning.background,
      border: `2px solid ${theme.palette.warning.main}`,
    },
  };

  return {
    display: "flex",

    color: theme.palette.common.white,
    ...(stylesMap[severity] || stylesMap?.error),

    padding: 20,
    borderRadius: theme.spacing(1),

    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: 16,
    lineHeight: 1.25,

    "& .MuiAlert-icon": {
      display: "flex",
      alignItems: "center",
      marginRight: theme.spacing(1),
      padding: 0,

      "& svg": {
        height: 16,
        width: 16,

        "& path": {
          fill: theme.palette.common.white,
        },
      },
    },

    "& .MuiAlert-message": {
      padding: 0,
      overflow: "unset",
    },
  };
});

export { StyledAlert };
